import DashboardRowIcon from './DashboardRowIcon';

export default DashboardRowIcon;
